




import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class SelfReferral extends Vue {
  public static navButtonClasses: string[] = ["self-referral"];
  public static navButtonLabel: () => string = () => "Self-refer to Practitioner Health";
}
